var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-2" },
    [
      _c("form", { attrs: { "data-vv-scope": "sign-document" } }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _c(
              "vs-select",
              {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "col-12 mb-2",
                attrs: {
                  autocomplete: "",
                  label: "Seleccione tipo de Firma",
                  name: "sign",
                  "data-vv-as": "tipo de firma",
                  danger: _vm.errors.has("sign-document.sign"),
                  "danger-text": _vm.errors.first("sign-document.sign")
                },
                model: {
                  value: _vm.signType,
                  callback: function($$v) {
                    _vm.signType = $$v
                  },
                  expression: "signType"
                }
              },
              _vm._l(_vm.userSignConfiguration.userSigns, function(firma) {
                return _c("vs-select-item", {
                  key: firma.id,
                  attrs: {
                    value: firma,
                    text: _vm.providerName(firma.proveedor),
                    disabled:
                      firma.proveedor ===
                        _vm.signerProviderConfigs.ASignAPI.key &&
                      firma.atendida,
                    title:
                      firma.proveedor === _vm.signerProviderConfigs.ASignAPI.key
                        ? "Esta firma no está habilitada para firma masiva"
                        : ""
                  }
                })
              }),
              1
            ),
            _vm.signerProviderConfig.otp
              ? _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required",
                      expression: "'required'"
                    }
                  ],
                  staticClass: "col-12 mb-2",
                  attrs: {
                    autocomplete: "off",
                    label: "Código OTP",
                    maxlength: "6",
                    name: "otp",
                    danger: _vm.errors.has("sign-document.otp"),
                    "danger-text": _vm.errors.first("sign-document.otp")
                  },
                  model: {
                    value: _vm.otpCode,
                    callback: function($$v) {
                      _vm.otpCode = $$v
                    },
                    expression: "otpCode"
                  }
                })
              : _vm._e(),
            _vm.signerProviderConfig.password
              ? _c("vs-input", {
                  directives: [
                    {
                      name: "validate",
                      rawName: "v-validate",
                      value: "required|min:6",
                      expression: "'required|min:6'"
                    }
                  ],
                  staticClass: "col-12",
                  attrs: {
                    autocomplete: "off",
                    type: "password",
                    label: "Contraseña de certificado",
                    name: "certificatePassword",
                    danger: _vm.errors.has("sign-document.certificatePassword"),
                    "danger-text": _vm.errors.first(
                      "sign-document.certificatePassword"
                    )
                  },
                  model: {
                    value: _vm.certificatePassword,
                    callback: function($$v) {
                      _vm.certificatePassword = $$v
                    },
                    expression: "certificatePassword"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ]),
      _c("b-overlay", { attrs: { show: _vm.loading } }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 text-right" },
            [
              _c(
                "b-button",
                {
                  staticClass: "mr-2",
                  attrs: {
                    "data-cy": "process-massive-button",
                    variant: "primary",
                    size: "sm"
                  },
                  on: { click: _vm.sendAction }
                },
                [_vm._v(" Firmar documentos ")]
              )
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }